var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1194_19047)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1663 7.5L11.3587 10.636C10.2461 11.8787 9.68984 12.5 8.95801 12.5C8.22617 12.5 7.66989 11.8787 6.55732 10.636L5.83301 9.82697",
    stroke: "#209829",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 2.20421C6.86757 1.41302 8.42006 0.997576 10 1.00001C14.9707 1.00001 19 5.02931 19 10C19 14.9707 14.9707 19 10 19C5.0293 19 1 14.9707 1 10C1 8.36111 1.4383 6.82301 2.2042 5.50001",
    stroke: "#209829",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1194_19047"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneIcon);
export default __webpack_public_path__ + "static/media/done_icon.495d1e85fa48e7cfb884fa233015861b.svg";
export { ForwardRef as ReactComponent };